const languageData = [
  {
    languageId: 'english',
    locale: 'en',
    name: 'English',
  },
  {
    languageId: 'spanish',
    locale: 'es',
    name: 'Spanish',
  },
  {
    languageId: 'french',
    locale: 'fr',
    name: 'French',
  },
  {
    languageId: 'italian',
    locale: 'it',
    name: 'Italian',
  },
  {
    languageId: 'german',
    locale: 'de',
    name: 'German',
  },
  {
    languageId: 'polish',
    locale: 'pl',
    name: 'Polish',
  },
  {
    languageId: 'portuguese',
    locale: 'pt',
    name: 'Português',
  },
  {
    languageId: 'russian',
    locale: 'ru',
    name: 'Русский',
  },
];

const DEFAULT_SUPPORTED_LANGUAGES = languageData
  .map((lang) => lang.locale)
  .filter((locale) => locale !== 'ru');

export function getSupportedLanguages() {
  const configuredLanguages = window.SUPPORTED_LANGUAGES || DEFAULT_SUPPORTED_LANGUAGES;
  return languageData.filter((lang) => configuredLanguages.includes(lang.locale));
}

export default languageData;
